"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var RadixCollapsible = _interopRequireWildcard(require("@radix-ui/react-collapsible"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _collapsibleCardTokens = require("./collapsibleCard.tokens.js");
var _jsxRuntime = require("react/jsx-runtime");
var HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "CollapsibleCard__HeaderWrapper",
  componentId: "sc-1jkbkwy-0"
})(["padding:", ";background-color:", ";"], _globalTokens.globalSpacing[400], _collapsibleCardTokens.tokens.color.header.background.default);
var ContentWrapper = (0, _styledComponents.default)(RadixCollapsible.Content).withConfig({
  displayName: "CollapsibleCard__ContentWrapper",
  componentId: "sc-1jkbkwy-1"
})(["padding:", ";background-color:", ";"], _globalTokens.globalSpacing[400], _collapsibleCardTokens.tokens.color.content.background.default);
var CollapsibleCardWrapper = (0, _styledComponents.default)(RadixCollapsible.Root).withConfig({
  displayName: "CollapsibleCard__CollapsibleCardWrapper",
  componentId: "sc-1jkbkwy-2"
})(["border:", ";border-radius:", ";overflow:hidden;> :not(:first-child){border-top:", ";}"], _collapsibleCardTokens.tokens.border.default, _globalTokens.globalBorder.radius["2"], _collapsibleCardTokens.tokens.border.default);
var Trigger = function Trigger(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixCollapsible.Trigger, {
    asChild: true,
    children: children
  });
};
var Header = function Header(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(HeaderWrapper, {
    children: children
  });
};
var Content = function Content(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentWrapper, {
    children: children
  });
};
var CollapsibleCard = function CollapsibleCard(_ref4) {
  var children = _ref4.children,
    open = _ref4.open;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CollapsibleCardWrapper, {
    open: open,
    children: children
  });
};
CollapsibleCard.Header = Header;
CollapsibleCard.Trigger = Trigger;
CollapsibleCard.Content = Content;
var _default = exports.default = CollapsibleCard;